import React from 'react';
import '../Styles/Blog_Post.css';
import contactBannerImg from '../../Asserts/Gallery_bg.png'; 

const Blog_Post = () => {
  return (
    <div
      className="bp-banner-container"
      style={{ backgroundImage: `url(${contactBannerImg})` }}
    >
     
     
      {/* OVERLAY */}
      <div className="bp-overlay"></div>

      {/* CONTENT */}
      <div className="bp-total">
        <div className="bp-content">
          <p>
            Our company blog shares insights, success stories, and updates that 
            reflect our journey of growth, innovation, and customer focus.
          </p>
        </div>

        <div className="bp-img-down">
          <p>
            Your contributions help us improve! Please share your comments.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Blog_Post;
